module.exports = __webpack_public_path__ + "static/media/Imagemobile.40a7104c.svg";